import _ from "lodash";

const peakABooHeader = ($) => {
	const header = $("#header");
	const headerNav = $("#header_nav");
	if (!headerNav || !headerNav[0]) return;

	const isHomepage = $("body").hasClass("home");
	let mobileSize = 1024;
	let isMobile = $(window).width() < mobileSize;

	const doc = document.documentElement;
	const w = window;

	let prevScroll = w.scrollY || doc.scrollTop;
	let curScroll;
	let direction = 0;
	let prevDirection = 0;

	const heightToShowBg = 200;

	// px value of when we slide the headerNav up
	let trigger = 30;

	// if announcement banner is present, need to push the nav elements down the page
	const announcementElement = $(".announcement");
	let isAnnouncementClosed = announcementElement.hasClass("announcement--close");
	let announcementHeight;
	let isAnnouncementInView = !isAnnouncementClosed;

	const calculateAnnouncementHeight = () => {
		if (isAnnouncementClosed) return;
		announcementHeight = announcementElement.outerHeight();
	};

	calculateAnnouncementHeight();

	// we update top value on mobile
	const setHeaderTop = (value = false) => {
		const topValue = value && isMobile ? `${value}px` : "";
		headerNav.css("top", topValue);
	};

	// we need to update margin-top on all screens to account for banner (if there is one)
	const setHeaderMarginTop = (value = false) => {
		const marginTopValue = value ? `${value}px` : "";
		header.css("margin-top", marginTopValue);    
	};

	const checkAnnouncement = (scrollPosition) => {
		if (isAnnouncementClosed) return;

		setHeaderMarginTop(announcementHeight);

		const announcementVisibleAmount = announcementHeight - scrollPosition;
		if (2 * announcementVisibleAmount > 0) {
			setHeaderTop(announcementVisibleAmount);
		} else {
			setHeaderTop();
		}
	};

	const checkIsAnnouncementClosed = () => {
		if (isAnnouncementClosed) return;
		// add click event to button
		const closeBtn = announcementElement.find(".js__announcement__button");
		closeBtn.on("click", () => {
			isAnnouncementClosed = true;
			setHeaderTop();
			setHeaderMarginTop(0); // Reset margin-top when announcement is closed
			closeBtn.off();
		});
	};

	checkIsAnnouncementClosed();

	const handleScroll = () => {
		/*
         ** Find the direction of scroll
         ** 0 - initial, 1 - up, 2 - down
         */

		curScroll = w.scrollY || doc.scrollTop;

		const checkAnnouncementIsInView = !isAnnouncementClosed && curScroll < announcementHeight;
		if (checkAnnouncementIsInView) {
			checkAnnouncement(curScroll);
		}
		// when value changes, run checkAnnouncement one more time to adjust the top value of the headerNav then flip the boolean
		if (checkAnnouncementIsInView !== isAnnouncementInView) {
			checkAnnouncement(curScroll);
			isAnnouncementInView = checkAnnouncementIsInView;
		}

		// on homepage, icons are white so we need to add a background
		// on other pages, the icons are black
		if (isHomepage) {
			const showBackground = curScroll > heightToShowBg;
			headerNav.toggleClass("background", showBackground);
		}

		if (curScroll > prevScroll) {
			//scrolled up
			direction = 2;
		} else if (curScroll < prevScroll) {
			//scrolled down
			direction = 1;
		}

		if (direction !== prevDirection) {
			toggleHeader(direction, curScroll);
		}

		prevScroll = curScroll;
	};

	handleScroll();

	const toggleHeader = (direction, curScroll) => {
		if (direction === 2 && curScroll > trigger) {
			headerNav.addClass("nav-up");
			prevDirection = direction;
		} else if (direction === 1) {
			headerNav.removeClass("nav-up");
			prevDirection = direction;
		}
	};

	const handleResize = () => {
		const windowWidth = $(window).width();
		let isMobileOldValue = isMobile;
		isMobile = windowWidth < mobileSize;

		if (isMobileOldValue !== isMobile) {
			calculateAnnouncementHeight();
			handleScroll();
		}

		if (isMobile) {
			window.addEventListener("scroll", _.throttle(handleScroll, 200));
		} else {
			window.removeEventListener("scroll", _.throttle(handleScroll, 200));
		}
	};
	handleResize();
	$(window).resize(_.debounce(handleResize, 200));
};

export default peakABooHeader;
